import { render, staticRenderFns } from "./sold-products-summary.vue?vue&type=template&id=66bec40e&scoped=true"
import script from "./sold-products-summary.vue?vue&type=script&lang=js"
export * from "./sold-products-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bec40e",
  null
  
)

export default component.exports